import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Splash } from '../graphics/svg/splash.svg';
import { ReactComponent as VeroSourceLogo } from '../graphics/svg/verosource-logo-grey.svg';
import { authClient } from '../auth';

/**
 * Splash page.
 * @returns {React.FunctionComponent} React element that contains the page.
 */
function SplashPage() {
  const { t } = useTranslation();

  return (
    <Container
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card>
        <CardContent>
          <Stack direction="row" spacing={3}>
            <Stack spacing={1} sx={{ justifyContent: 'space-between' }}>
              <Typography variant="h4" color="primary">
                {t('pages.splash.title')}
              </Typography>
              <Typography>{t('pages.splash.message')}</Typography>
              <Stack
                direction="row"
                spacing={1}
                sx={{ alignItems: 'center', justifyContent: 'space-between' }}
              >
                <VeroSourceLogo height={45} />
                <Button
                  variant="contained"
                  onClick={() => authClient.signinRedirect()}
                >
                  {t('pages.splash.button')}
                </Button>
              </Stack>
            </Stack>
            <Box sx={{ minWidth: 375 }}>
              <Splash />
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}

export default SplashPage;
